/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class InfraVulnerabilitySourceQueryOperator extends models.QueryOperator {
    constructor() {
        super();
        this.setDiscriminator("InfraVulnerabilitySourceQueryOperator");
    }

    getFixupPrototypeFunction() { return InfraVulnerabilitySourceQueryOperator.fixupPrototype; }

    static newInstance(model: Partial<InfraVulnerabilitySourceQueryOperator>): InfraVulnerabilitySourceQueryOperator {
        let obj = Object.assign(new InfraVulnerabilitySourceQueryOperator(), model);
        InfraVulnerabilitySourceQueryOperator.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<InfraVulnerabilitySourceQueryOperator>): InfraVulnerabilitySourceQueryOperator {
        if (!model) return null;
        return InfraVulnerabilitySourceQueryOperator.newInstance(<InfraVulnerabilitySourceQueryOperator> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: InfraVulnerabilitySourceQueryOperator) {
        if (!obj) return;

        models.InfraVulnerabilitySourceQueryOperator.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: InfraVulnerabilitySourceQueryOperator): boolean {
        if (models.QueryOperator.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, InfraVulnerabilitySourceQueryOperator.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Sources of the vulnerability to include
     */
    sources: Array<models.InfraVulnerabilitySource>;

}
